// extracted by mini-css-extract-plugin
export default {"loader":"loader__k28Qdv","transcribeModal":"transcribeModal__bCSlmX"};